export class ChangePasswordRequest {
  password: string;
  oldPassword: string;
  confirmPassword?: string;

  constructor(oldPassword: string, password: string) {
    this.password = password;
    this.oldPassword = oldPassword;
  }
}
